import React from 'react'

import DesktopDrawer from './DesktopDrawer'
import MobileDrawer from './MobileDrawer'
import { useIsDesktop } from '@edge/spark/ui-mui'

const SideDrawer = (): React.ReactElement => {
    const desktop = useIsDesktop()

    return desktop ? <DesktopDrawer /> : <MobileDrawer />
}

export default SideDrawer
